// Presentation input for the first Windows release. The release owner fills
// these only from accepted, publicly admitted release records. Mac releases,
// shared SKU prices and environment flags cannot open Windows sales.
export const WINDOWS_RELEASE_EVIDENCE = Object.freeze({
  secureshield: null,
  "securemac-pro": null,
});
